import styled from "styled-components"

import Hr from "@irati/ui/src/Layout/Hr"

const StyledHr = styled(Hr)`
  margin: 0;
  border-top: 1px solid ${({theme}) => theme.colors.greys.light};
`

export default StyledHr
